export default __webpack_public_path__ + "static/18963-72eeb222b0cba9ebe30eebf0fe63a95c.jpg";